module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"m2 21 21-9L2 3v7l15 2-15 2v7Z\"/></svg>";